import { memo } from 'react';

import { WorklistFilterAccordionItemProps } from '../types';
import { WorklistFieldFilterAccordionItem } from './WorklistFieldFilterAccordionItem';
import { WorklistTagFilterAccordionItem } from './WorklistTagFilterAccordionItem';

export const WorklistFilterAccordionItem = memo<WorklistFilterAccordionItemProps>(
  ({
    worklist,
    allWorklists,
    isTopLevel = false,
    currentDataState,
    currentColumnsState,
    onCreateWorklist,
    onDeleteWorklist,
    onUpdateWorklist,
    filterType,
    patientId,
    dndType,
  }) => {
    if (filterType === 'tag') {
      return (
        <WorklistTagFilterAccordionItem
          worklist={worklist}
          allWorklists={allWorklists}
          isTopLevel={isTopLevel}
          currentDataState={currentDataState}
          currentColumnsState={currentColumnsState}
          onCreateWorklist={onCreateWorklist}
          onDeleteWorklist={onDeleteWorklist}
          onUpdateWorklist={onUpdateWorklist}
          patientId={patientId}
          dndType={dndType}
        />
      );
    }

    if (filterType === 'field') {
      return (
        <WorklistFieldFilterAccordionItem
          worklist={worklist}
          allWorklists={allWorklists}
          isTopLevel={isTopLevel}
          currentDataState={currentDataState}
          currentColumnsState={currentColumnsState}
          onCreateWorklist={onCreateWorklist}
          onDeleteWorklist={onDeleteWorklist}
          onUpdateWorklist={onUpdateWorklist}
          patientId={patientId}
          dndType={dndType}
        />
      );
    }

    throw new Error(`Unsupported filterType: ${filterType}`);
  },
);

WorklistFilterAccordionItem.displayName = 'WorklistFilterAccordionItem';
